import React, { useCallback } from "react";
import { useField } from "formik";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import Input from "../Input";

const initialPhysicalDimensions = {
  depth: "",
  width: "",
  height: "",
};

const PhysicalDimensionsField = ({ name }) => {
  const [field, , helpers] = useField({ name });
  const fields = field.value || [];

  const handleAddNew = useCallback(() => {
    helpers.setValue(fields.concat(initialPhysicalDimensions));
  }, [helpers, fields]);

  const handleRemove = useCallback(
    i => helpers.setValue(fields.filter((v, index) => i !== index)),
    [helpers, fields]
  );

  return (
    <>
      {fields.map((v, index) => (
        <Grid key={index} size={12}>
          <Box display="flex" alignItems="center">
            <Grid container spacing={1}>
              <Grid size={4}>
                <Input name={`${name}.${index}.width`} label="Width (in)" />
              </Grid>
              <Grid size={4}>
                <Input name={`${name}.${index}.depth`} label="Depth (in)" />
              </Grid>
              <Grid size={4}>
                <Input name={`${name}.${index}.height`} label="Height (in)" />
              </Grid>
            </Grid>
            {fields.length > 0 && (
              <IconButton
                aria-label="delete"
                variant="outlined"
                sx={{ p: 1, mr: -1 }}
                onClick={() => handleRemove(index)}
              >
                <DeleteIcon color="action" />
              </IconButton>
            )}
          </Box>
        </Grid>
      ))}
      <Grid size={12}>
        <Button
          id={`addNew-${name.split(".").join("-")}`}
          variant="outlined"
          onClick={handleAddNew}
        >
          Add New <AddIcon color="action" fontSize="small" />
        </Button>
      </Grid>
    </>
  );
};

export default React.memo(PhysicalDimensionsField);
